import { useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { useRegion } from 'shared/components/RegionSwitcher/RegionProvider';
import Auth from '@nordvpn/teams.core/lib/auth';
import { isLoggedIn } from '@nordvpn/teams.core/lib/auth/utils/localStorage';
import { STORAGE_NAME_AUTH } from 'pages/LoginOld/constants';
import { Features } from 'types/features/enums';
import { getAvailableRedirectPath } from 'utils/routing/getAvailableRedirectPath';
import { getPathWithRegion } from 'utils/routing/getPathWithRegion';
import { getRedirectPathItemsForRegion } from 'utils/routing/regionAvailability';
import { useFeatureFlag } from 'utils/useFeatureFlag';
import { useAccount } from 'api/Account/queries';
/**
 * Redirects to the first available path from the sidebarItems list based on the user's permissions.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var RedirectByPermission = function RedirectByPermission() {
    var loggedIn = isLoggedIn(STORAGE_NAME_AUTH);
    var _useAccount = useAccount({
        enabled: loggedIn
    }), account = _useAccount.data;
    var _ref = account !== null && account !== void 0 ? account : {}, permissions = _ref.permissions;
    var isMultiRegionEnabled = useFeatureFlag(Features.MultiRegionSwitcher);
    var region = useRegion();
    var redirectPath = useMemo(function () {
        var path = getAvailableRedirectPath(getRedirectPathItemsForRegion(region), permissions !== null && permissions !== void 0 ? permissions : []);
        return isMultiRegionEnabled ? getPathWithRegion(path, region) : path;
    }, [permissions, region, isMultiRegionEnabled]);
    return /*#__PURE__*/ _jsx(Redirect, {
        to: loggedIn ? redirectPath : Auth.constants.LOGIN
    });
};
